/* GMU cart (T6). Source: gmu-audit/mockups/final/data/cart-drawer.html.
   cart-drawer: replaces the theme's element of the same name (assets/cart-drawer.js is no longer loaded on the
   dev theme). Keeps its public API (getSectionsToRender, renderContents, setActiveElement, open, close) so
   product-form.js, quick-add.js and gmu-product.js work unchanged.
   gmu-cart-page: the /cart page, same line actions.
   Line actions: qty -/+ and remove via /cart/change.js, size = /cart/add.js new variant then /cart/change.js old
   line to 0, upsell tile = /cart/add.js. Every call asks for the sections back (Section Rendering API). */
(function () {
  if (customElements.get('cart-drawer') && customElements.get('gmu-cart-page')) return;

  var R = window.routes || {};
  var VERSIONS = /^[ABC]$/;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) {}
        /* non-JSON (HTML error page, rate limit): empty message = the translated data-err-text */
        if (!j) throw new Error('');
        if (!r.ok || j.status) {
          var err = new Error(j.description || j.message || '');
          err.shopify = true;
          throw err;
        }
        return j;
      });
    });
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function publishUpdate(res) {
    if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gmu-cart', cartData: res }); } catch (e) {}
    }
  }

  function applyBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    var sec = parse(html).querySelector('.shopify-section');
    if (sec) el.innerHTML = sec.innerHTML;
  }

  /* version: ?cd=A|B|C (kept for the tab in sessionStorage), else the theme setting on data-v */
  function pickVersion(root) {
    var v = null;
    try {
      var q = (location.search.match(/[?&]cd=([ABC])\b/) || [])[1];
      if (q) sessionStorage.setItem('gmu-cd', q);
      v = q || sessionStorage.getItem('gmu-cd');
    } catch (e) {}
    if (v && VERSIONS.test(v)) root.setAttribute('data-v', v);
  }

  /* shared line-action handling. host: element with .inner() (content node), .sectionIds(), .apply(sections).
     qty -/+ clicks are queued per line (target qty shown at once), so 3 quick clicks = +3.
     On any error (e.g. 422 not enough stock, Shopify still adds what it can) the sections are fetched again so the
     bag shows the real cart, then the message is shown on the line. */
  function bindActions(host) {
    var busy = false;
    host._want = {};
    var sent = {}; /* qty target of the request in flight, per line key */
    function lineOf(el) { return el.closest('.cd-line'); }
    function lineBy(attr, val) {
      if (val == null) return null;
      var c = host.inner();
      return c ? c.querySelector('.cd-line[' + attr + '="' + CSS.escape(String(val)) + '"]') : null;
    }
    function showErr(line, msg) {
      var box = line ? line.querySelector('[data-err]') : host.querySelector('[data-cd-err]');
      if (box) box.textContent = msg || host.getAttribute('data-err-text') || 'Error';
    }
    function refresh() {
      return fetch(window.location.pathname + '?sections=' + host.sectionIds().join(','))
        .then(function (r) { if (!r.ok) throw new Error(''); return r.json(); })
        .then(function (sections) { host.apply(sections || {}); });
    }
    function run(line, promise, hint) {
      busy = true;
      host.setAttribute('aria-busy', 'true');
      if (line) line.classList.add('is-busy');
      hint = hint || {};
      return promise.then(function (res) {
        host.apply(res.sections || {});
        publishUpdate(res);
        return res;
      }).catch(function (err) {
        var msg = err && err.shopify ? err.message : '';
        return refresh().then(function () {
          showErr(lineBy('data-key', hint.key) || lineBy('data-variant', hint.variant), msg);
        }, function () {
          if (line) line.classList.remove('is-busy');
          showErr(line, msg);
        });
      }).finally(function () {
        sent = {};
        busy = false;
        host.removeAttribute('aria-busy');
        flush();
      });
    }
    function withSections(body) {
      body.sections = host.sectionIds().join(',');
      body.sections_url = window.location.pathname;
      return body;
    }
    function change(line, key, qty) {
      return run(line, post((R.cart_change_url || '/cart/change') + '.js', withSections({ id: key, quantity: qty })), { key: key });
    }
    /* send the next queued qty target */
    function flush() {
      if (busy) return;
      var keys = Object.keys(host._want);
      if (!keys.length) return;
      var k = keys[0], t = host._want[k];
      delete host._want[k];
      sent[k] = t;
      var l = lineBy('data-key', k);
      if (!l || parseInt(l.getAttribute('data-qty'), 10) === t) { flush(); return; }
      host.focusKey = host.focusKey || ['inc', k];
      change(l, k, t);
    }

    host.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b || b.tagName === 'SELECT') return;
      var act = b.getAttribute('data-act'), line = lineOf(b), key = b.getAttribute('data-key');
      var qty = line ? parseInt(line.getAttribute('data-qty'), 10) : 0;
      if (act === 'inc' || act === 'dec') {
        var base = key in host._want ? host._want[key] : key in sent ? sent[key] : qty;
        if (act === 'dec' && base <= 1) return;
        var t = act === 'inc' ? base + 1 : base - 1;
        host._want[key] = t;
        var out = line.querySelector('output');
        if (out) out.textContent = t;
        if (!busy) host.focusKey = [act, key];
        flush();
        return;
      }
      if (busy) return;
      host.focusKey = [act, key];
      if (act === 'rm') { delete host._want[key]; change(line, key, 0); }
      else if (act === 'up') {
        var vid = parseInt(b.getAttribute('data-variant'), 10);
        run(null, post((R.cart_add_url || '/cart/add') + '.js', withSections({ items: [{ id: vid, quantity: 1 }] })), { variant: vid });
      }
    });

    host.addEventListener('change', function (e) {
      var s = e.target.closest('select[data-act]');
      if (!s) return;
      if (s.getAttribute('data-act') === 'ship') {
        var o = s.options[s.selectedIndex];
        var root = s.closest('.cd-foot') || host;
        var so = root.querySelector('[data-ship-out]'), to = root.querySelector('[data-total-out]');
        if (so) so.textContent = o.getAttribute('data-ship');
        if (to) to.textContent = o.getAttribute('data-total');
        try { sessionStorage.setItem('gmu-cd-ship', s.value); } catch (x) {}
        return;
      }
      if (s.getAttribute('data-act') !== 'size') return;
      var line = lineOf(s), key = s.getAttribute('data-key');
      if (busy) { s.value = line.getAttribute('data-variant'); return; }
      var qty = parseInt(line.getAttribute('data-qty'), 10);
      var props = {};
      try { props = JSON.parse(s.getAttribute('data-props') || '{}') || {}; } catch (x) {}
      var newId = parseInt(s.value, 10);
      var item = { id: newId, quantity: qty };
      if (Object.keys(props).length) item.properties = props;
      /* qty of the new size already in the bag, to tell whether a failed add still added some */
      var before = 0;
      host.inner().querySelectorAll('.cd-line[data-variant="' + newId + '"]').forEach(function (l) { before += parseInt(l.getAttribute('data-qty'), 10) || 0; });
      delete host._want[key];
      host.focusKey = ['size', null];
      var zeroOld = function () { return post((R.cart_change_url || '/cart/change') + '.js', withSections({ id: key, quantity: 0 })); };
      /* add the new size first: if nothing was added (stock) the old line stays untouched */
      run(line, post((R.cart_add_url || '/cart/add') + '.js', { items: [item] }).then(zeroOld, function (err) {
        return fetch((R.cart_url || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) {
          var now = 0;
          (c.items || []).forEach(function (i) { if (i.variant_id === newId) now += i.quantity; });
          if (now > before) return zeroOld().then(function () { throw err; });
          throw err;
        }, function () { throw err; });
      }), { key: key, variant: newId });
    });
  }

  /* restore focus to the same control after a re-render; keep the chosen shipping country */
  function afterRender(host) {
    var content = host.inner();
    var live = host.querySelector('[data-cd-live]');
    if (live && content && content.getAttribute('data-live')) {
      live.textContent = '';
      setTimeout(function () { live.textContent = content.getAttribute('data-live'); }, 60);
    }
    Object.keys(host._want || {}).forEach(function (k) {
      var l = content.querySelector('.cd-line[data-key="' + CSS.escape(k) + '"] output');
      if (l) l.textContent = host._want[k];
    });
    if (host.noteVal != null) {
      var n = content.querySelector('[data-cd-note]');
      if (n) n.value = host.noteVal;
    }
    try {
      var ship = sessionStorage.getItem('gmu-cd-ship'), sel = content.querySelector('select[data-act="ship"]');
      if (ship && sel && sel.value !== ship && sel.querySelector('option[value="' + ship + '"]')) {
        sel.value = ship;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {}
    var fk = host.focusKey;
    host.focusKey = null;
    if (!fk) return;
    var cands = content.querySelectorAll('[data-act="' + fk[0] + '"]' + (fk[1] ? '[data-key="' + fk[1] + '"]' : ''));
    for (var i = 0; i < cands.length; i++) {
      if (!cands[i].disabled && cands[i].offsetParent !== null) { cands[i].focus(); return; }
    }
    host.focusFallback();
  }

  /* ---------- drawer ---------- */
  class GmuCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var sec = this.closest('.shopify-section');
      if (sec) this.dataset.sid = sec.id;
      /* editor reload: drop a stale moved copy of the drawer before appending this one */
      var me = this;
      document.querySelectorAll('cart-drawer.cd-root').forEach(function (d) { if (d !== me) d.remove(); });
      if (this.parentElement !== document.body) document.body.appendChild(this);
      pickVersion(this);
      this.panel = this.querySelector('.cd');
      var self = this;
      this.inner = function () { return self.querySelector('#CartDrawer'); };
      this.sectionIds = function () { return self.getSectionsToRender().map(function (s) { return s.id; }); };
      this.apply = function (sections) { self.applySections(sections); };
      this.focusFallback = function () { self.panel.focus(); };
      bindActions(this);

      this.addEventListener('click', function (e) { if (e.target.closest('[data-cd-close]')) self.close(); });
      this._onKey = function (e) { self.onKey(e); };
      this.bindBags();
      this.loadRecs();

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector && e.target.querySelector('cart-drawer')) self.open(); });
        document.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector && e.target.querySelector('cart-drawer')) self.close(); });
        document.addEventListener('shopify:section:unload', function (e) {
          if (!self.isConnected || !e.detail || 'shopify-section-' + e.detail.sectionId !== self.dataset.sid) return;
          self.close();
          self.remove();
        });
      }
    }

    bindBags() {
      var self = this;
      document.querySelectorAll('.cart-icon--drawer').forEach(function (a) {
        if (a.dataset.gmuCart) return;
        a.dataset.gmuCart = '1';
        a.setAttribute('role', 'button');
        a.setAttribute('aria-haspopup', 'dialog');
        /* look the drawer up at click time: the editor can replace it */
        var go = function () { var d = document.querySelector('cart-drawer.cd-root') || self; d.open(a); };
        a.addEventListener('click', function (e) { e.preventDefault(); go(); });
        a.addEventListener('keydown', function (e) { if (e.code === 'Space') { e.preventDefault(); go(); } });
      });
    }

    /* theme API */
    getSectionsToRender() {
      return [{ id: 'gmu-cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
    }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(state) {
      this.focusKey = null;
      this.applySections((state && state.sections) || {});
      this.open();
    }

    applySections(sections) {
      var html = sections['gmu-cart-drawer'];
      if (html) {
        var next = parse(html).querySelector('#CartDrawer'), cur = this.inner();
        if (next && cur) {
          var body = cur.querySelector('.cd-body'), top = body ? body.scrollTop : 0;
          cur.replaceWith(next);
          var nb = next.querySelector('.cd-body');
          if (nb) nb.scrollTop = top;
          this.loadRecs();
          afterRender(this);
        }
      }
      applyBubble(sections);
    }

    loadRecs() {
      var ph = this.querySelector('[data-cd-up]');
      if (!ph || !ph.dataset.url) return;
      this._recs = this._recs || {};
      var key = ph.dataset.url + '|' + ph.dataset.sig, self = this;
      var put = function (html) { if (ph.isConnected && html) ph.innerHTML = html; };
      if (key in this._recs) { put(this._recs[key]); return; }
      fetch(ph.dataset.url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var frag = html ? parse(html).querySelector('[data-cd-recs]') : null;
        var out = frag && frag.querySelector('.cd-up') ? frag.innerHTML : '';
        self._recs[key] = out;
        put(out);
      }).catch(function () {});
    }

    open(trigger) {
      if (trigger) this.activeElement = trigger;
      if (!this.classList.contains('is-open') && !this.activeElement) this.activeElement = document.activeElement;
      this.classList.add('is-open');
      document.documentElement.classList.add('cd-lock');
      document.addEventListener('keydown', this._onKey);
      var p = this.panel;
      setTimeout(function () { if (!p.contains(document.activeElement)) p.focus(); }, 30);
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('cd-lock');
      document.removeEventListener('keydown', this._onKey);
      var a = this.activeElement;
      this.activeElement = null;
      if (a && a.isConnected && a.focus) a.focus();
    }

    onKey(e) {
      if (e.key === 'Escape') { this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(this.panel.querySelectorAll('button, a[href], select, input, [tabindex]:not([tabindex="-1"])'), function (x) {
        return !x.disabled && x.offsetParent !== null;
      });
      if (!f.length) { e.preventDefault(); this.panel.focus(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (!this.panel.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (a === first || a === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* ---------- /cart page ---------- */
  class GmuCartPage extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      pickVersion(this);
      var self = this, sid = this.getAttribute('data-section-id');
      this.inner = function () { return self.querySelector('#GmuCartPage'); };
      this.sectionIds = function () { return [sid, 'cart-icon-bubble']; };
      this.apply = function (sections) {
        var html = sections[sid];
        if (html) {
          var next = parse(html).querySelector('#GmuCartPage'), cur = self.inner();
          if (next && cur) { cur.replaceWith(next); afterRender(self); }
        }
        applyBubble(sections);
      };
      this.focusFallback = function () { var h = self.querySelector('.cd-page__h'); if (h) { h.tabIndex = -1; h.focus(); } };
      bindActions(this);
      /* order note: saved via /cart/update.js, debounced */
      var timer = null;
      this.addEventListener('input', function (e) {
        var n = e.target.closest('[data-cd-note]');
        if (!n) return;
        self.noteVal = n.value;
        clearTimeout(timer);
        timer = setTimeout(function () {
          post((R.cart_update_url || '/cart/update') + '.js', { note: self.noteVal }).then(function () {
            var ok = self.querySelector('[data-cd-note-ok]'), cur = self.querySelector('[data-cd-note]');
            if (ok && cur) ok.textContent = cur.getAttribute('data-saved');
          }).catch(function () {
            var box = self.querySelector('[data-cd-err]');
            if (box) box.textContent = self.getAttribute('data-err-text');
          });
        }, 600);
      });
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', GmuCartDrawer);
  if (!customElements.get('gmu-cart-page')) customElements.define('gmu-cart-page', GmuCartPage);
})();
